import { createSlice, PayloadAction } from "@reduxjs/toolkit";
export interface DataType {
  newVehCharge: any;
  id: string;
  key: string;
  cabId: string;
  cab_id: string;
  toPayPercent: any;
  totalFare?: number;
  amount: number;
  balance: number;
  days: number;
  prepaid: number;
  payments: number;
  serviceCharges: number;
  attendance: number;
  branding: number;
  totalAmount: number;
  creditAmount: number;
  addPayments: number;
  paid: number;
  amountBalance: number;
  status: string;
  proplus: number;
  bonus: number;
  moreInfo: string;
  remarks?: string;
  prevBal: number;
}
interface VehicleAccountState {
  data: DataType[];
  loading: boolean;
  error: string | null;
}
const initialState: any = {
  create: { creating: false, success: false },
  update: { update: false, success: false },
  data: [],
  loading: false,
  error: null,
};
const vehicleAccountSlice = createSlice({
  name: "vehicleAccount",
  initialState,
  reducers: {
    fetchVehicleAccountsRequest(state) {
      state.loading = true;
      state.error = null;
    },
    fetchVehicleAccountsSuccess(state, action: PayloadAction<DataType[]>) {
      state.loading = false;
      state.data = action.payload;
    },
    fetchVehicleAccountsFailure(state, action: PayloadAction<string>) {
      state.loading = false;
      state.error = action.payload;
    },
    CreatePaymentRequest(state) {
      state.create = { creating: true, success: false };
    },
    createPaymentSuccess(state: any, action) {
      state.create = { creating: false, success: true };
    },
    createPaymentFailure(state, action) {
      state.create = { creating: false, success: false };
    },
    CreatePaidPaymentRequest(state) {
      state.create = { creating: true, success: false };
    },
    createPaidPaymentSuccess(state: any, action) {
      state.create = { creating: false, success: true };
    },
    createPaidPaymentFailure(state, action) {
      state.create = { creating: false, success: false };
    },
    UpdateTopayRequest(state) {
      state.update = { update: true, success: false };
    },
    UpdateTopaySuccess(state: any, action) {
      state.update = { update: false, success: true };
      state.toPayData = action.payload;
    },
    UpdateTopayFailure(state, action) {
      state.update = { update: false, success: false };
    },
    SendPdfRequest(state) {
      state.update = { update: true, success: false };
    },
    SendPdfSuccess(state: any, action) {
      state.update = { update: false, success: true };
      // state.toPayData = action.payload;
    },
    SendPdfFailure(state, action) {
      state.update = { update: false, success: false };
    },
  },
});
export const {
  fetchVehicleAccountsRequest,
  fetchVehicleAccountsSuccess,
  fetchVehicleAccountsFailure,
  CreatePaymentRequest,
  createPaymentSuccess,
  createPaymentFailure,
  CreatePaidPaymentRequest,
  createPaidPaymentSuccess,
  createPaidPaymentFailure,
  UpdateTopayRequest,
  UpdateTopaySuccess,
  UpdateTopayFailure,
  SendPdfRequest,
  SendPdfSuccess,
  SendPdfFailure,
} = vehicleAccountSlice.actions;
export default vehicleAccountSlice.reducer;
